import { memo } from "react";
import { DraftDrawingRender } from "./DraftDrawingRender";
import { PolygonRender } from "./PolygonRender";
import type { PolygonsLayerProps } from "./types";

export const PolygonsLayer = memo(function PolygonsLayer({
  overlay,
  zoomLevel,
  circleSizeScale = 1,
}: PolygonsLayerProps) {
  return (
    <g>
      {overlay.polygons.map((polygon) => {
        if (polygon.isDraft && overlay.isDrawing) {
          return (
            <DraftDrawingRender
              key={polygon.id}
              points={polygon.points}
              hoverPosition={overlay.hoverPosition}
              zoomLevel={zoomLevel}
              circleSizeScale={circleSizeScale}
            />
          );
        }
        return (
          <PolygonRender
            key={polygon.id}
            polygon={polygon}
            isInteractive={overlay.isInteractive}
            isEditable={overlay.isEditable}
            selectedPointId={overlay.selectedPointId}
            zoomLevel={zoomLevel}
            circleSizeScale={circleSizeScale}
            onPolygonClick={overlay.onPolygonClick}
            onNodeMouseDown={overlay.onNodeMouseDown}
            onSegmentMouseDown={overlay.onSegmentMouseDown}
          />
        );
      })}
    </g>
  );
});
